// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Log$SmartcutsMacros = require("../Log.bs.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");

function sendCommandPromiseCallback(maybeError) {
  if (maybeError === undefined) {
    return Promise.resolve(undefined);
  }
  var lastError = browser.runtime.lastError;
  if (lastError == null) {
    return Promise.resolve(undefined);
  }
  Curry._2(Log$SmartcutsMacros.cdp.log2, "lastError", lastError);
  var message = lastError.message;
  if (message !== undefined) {
    return Util$SmartcutsMacros.logAndRaiseJsError(message);
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("An unknown error occurred");
  }
}

exports.sendCommandPromiseCallback = sendCommandPromiseCallback;
/* Log-SmartcutsMacros Not a pure module */
